import React from 'react';

import Page from '../../components/Page';

import { getSidebarActions } from '../../sections/employee/tfg/SidebarActions';
import TableView from '../../sections/employee/generics/TableView';
import { getDataGridProps } from '../../sections/employee/tfg/DatagridProps';
import TfgFilter from '../../sections/employee/tfg/Filter';
import RowActions from '../../sections/employee/tfg/RowActions';
import TfgProvider, { useTfg } from '../../sections/employee/tfg/TfgContext';

export const Tfg = () => <Page title="TFG">
  <TfgProvider>
    <TableView
      sidebarActions={getSidebarActions()}
      dataGridProps={getDataGridProps() }
      FilterComponent= {TfgFilter}
      RowActionsComponent={RowActions}
      useCtx={useTfg}
      showStatePanel={false}
    />
  </TfgProvider>
</Page>;
